<script setup>
import { computed } from 'vue';
import { getImageNameNoExt } from '@/utils/dom-utils';
import config from '@/temp/config';
const props = defineProps({
  field: {
    type: Object,
    required: true,
  },
  loading: {
    type: String,
    default: 'lazy',
  },
});
const image = computed(() => {
  if (!props.field) {
    return null;
  }
  const result = structuredClone(props.field);
  const src = result.value?.src;
  if (!src) {
    return null;
  }
  // result.value.src = src.startsWith('http') ? src : config.imageHostPrefix + src;
  return result;
});
const imageAlt = computed(() => {
  const { alt, src } = props.field?.value || {};
  if (alt && alt.trim() !== '') {
    return alt;
  }
  if (src) {
    return getImageNameNoExt(src);
  }
  return '';
});
</script>
<template>
  <jss-image :media="image" :alt="imageAlt" v-bind="$attrs" :loading="loading" />
</template>
<style lang="scss">
@import '../styles/variables';
@import '../styles/functions';
@import '../styles/mixins';
</style>
